type FacebookVerificationMetaProps = {
  facebookVerificationId: string;
};

export function FacebookVerificationMeta({ facebookVerificationId }: FacebookVerificationMetaProps) {
  if (!facebookVerificationId) {
    return null;
  }

  return (
    <meta key="facebook-verification" name="facebook-domain-verification" content={facebookVerificationId ?? ''} />
  );
}
